// allow multiple triggers to dropdown within uib-dropdown
(function(angular) {
    'use strict';

    // this is the property that uibDropdownToggle directive sets for the element triggering the toggle
    var toggleElementProp = 'toggleElement';

    angular.module('aprima-core-ui').decorator('uibDropdownDirective', [
        '$delegate',
        '$document',
        uibDropDownDecorator
    ]);

    function uibDropDownDecorator(
        $delegate,
        $document
    ) {

        var directive = $delegate[0];
        var compile = directive.compile;
        var uibDropdownToggleSelector = '[uib-dropdown-toggle],.uib-dropdown-toggle,.dropdown-toggle';

        directive.compile = function() {
            var link = compile.apply(this, arguments);

            return function(scope, element, attrs, dropdownCtrl) {
                if(dropdownCtrl) {
                    $document.on('click', uibDropdownToggleSelector, setToggleElement);

                    scope.$on('$destroy', function() {
                        $document.off('click', uibDropdownToggleSelector, setToggleElement);
                    });
                }

                function setToggleElement(ev){
                    dropdownCtrl[toggleElementProp] = angular.element(ev.currentTarget);
                }

                link.apply(this, arguments);
            };
        };

        return $delegate;
    }

})(window.angular);
